'use strict';

var versionModule = require('./_index.js');

versionModule.value('version', '1.0');